import CourseCard from "@/components/common/card/CourseCard";
import CommonImage from "@/components/common/image/CommonImage";
import SectionTitle from "@/components/common/section-title/SectionTitle";
import { Empty, Spin } from "antd";
import React from "react";
import { IoChevronDown } from "react-icons/io5";

export default function CoursePageCard({
  loading,
  programs,
  selectedProgram,
  handleProgramClick,
  classes,
  selectedClassId,
  handleClassClick,
  courses,
  hasMore,
  handleLoadMore,
}) {
  return (
    <section className="course_section section_padding">
      <div className="container">
        <div className="course-section-card">
          {/* {loading ? (
            <div className="flex items-center justify-center h-[200px] w-full col-span-full">
              <Spin size="large" />
            </div>
          ) : (
            <> */}
          <SectionTitle
            iconSrc={"/images/home-page/book-icon.avif"}
            title={selectedProgram?.name ?? ""}
            description={
              "ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।"
            }
          />

          {/* programs */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6 my-8 course_prorams">
            {programs?.map((item, index) => (
              <div
                className="program-item"
                key={index}
                onClick={() => handleProgramClick(item)}
              >
                <div
                  className={`item-card ${
                    selectedProgram?.slug === item.slug ? "active" : ""
                  }`}
                >
                  <div className="program-icon">
                    <CommonImage
                      src={item.icon_url}
                      className="img-icon"
                      alt="Program Icon"
                    />
                  </div>
                  <div className="item-content">
                    <h4 className="title">{item.name}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* classes */}
          <div className="flex flex-wrap gap-3 md:gap-4 lg:gap-6 my-5 md:my-8 course_classes">
            {classes?.map((item, index) => (
              <div
                key={index}
                onClick={() => handleClassClick(item.id)}
                className={`class-item ${
                  selectedClassId === item.id ? "active" : ""
                }`}
              >
                <div className="item-content">
                  <h4 className="title">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>

          {/* Courses */}
          <div className="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-3 md:gap-4 md:gap-6 courses">
            {courses.length > 0 ? (
              courses.map((item, index) => (
                <CourseCard key={index} course={item} />
              ))
            ) : (
              <div className="col-span-full">
                <Empty description="No course available" />
              </div>
            )}
          </div>

          {/* see more button */}
          {hasMore && (
            <div className="text-center mt-8">
              <button onClick={handleLoadMore} className="seemore-btn">
                আরো দেখো <IoChevronDown />
              </button>
            </div>
          )}
          {/* </> */}
          {/* )} */}
        </div>
      </div>
    </section>
  );
}
